import React from 'react'
import { Widget, Action, mk_widget } from 'widgets-for-react'
import { HeaderState, OptionsState, PublicSiteState } from '../../public_site.main.mod'
import { t } from 'i18next'
import { NavLink } from 'react-router-dom'
import MainNavItems from './nav_items_main'
import Wave from 'react-wavify'
import { enableReducedMotion } from '../custom_pages/Fc150YearsWidget/Fc150Years.utils'
import { headerBlockData } from '../blocks/custom_blocks/types.mod'

export const navigation: (s: PublicSiteState, h: HeaderState, o: OptionsState) => Widget<Action<HeaderState>> = (
  s0,
  props,
  opts
) =>
  mk_widget({
    run: setState => {

      const toggleHeader = (s: HeaderState): HeaderState => {
        let headerBlock = s0.page.blocks.find(b => b.kind == 'headerBlock') as headerBlockData
        if (headerBlock != undefined && headerBlock.value.fst.video_playing) return s
        return ({ ...s, menu: s.menu == 'open' ? 'closed' : 'open' })
      }

      let wavePaused: boolean = enableReducedMotion;
      if(s0.header.menu != 'open') {
        wavePaused = true;
      }

      return (
        <>
          <header className="header header--150">
            <div className="header__inner">
              {s0.Fc150YearsMainPage.current_page == '404' ?
                <a href={`/${window.wp.language}/`} className="header__link">
                  <span className="sr-text">{window.wp.language == 'en' ? "Return to homepage of FrieslandCampina 150 years" : "Keer terug naar homepage van FrieslandCampina 150 jaar"}</span>
                  <img className="header__logo--150" src="/frontend/images/logo--150.svg" alt="" width="170" height="106" aria-hidden="true" />
                </a>
                :
                <NavLink to={`/${window.wp.language}/`} className="header__link">
                  <span className="sr-text">{window.wp.language == 'en' ? "Return to homepage of FrieslandCampina 150 years" : "Keer terug naar homepage van FrieslandCampina 150 jaar"}</span>
                  <img className="header__logo--150" src="/frontend/images/logo--150.svg" alt="" width="170" height="106" aria-hidden="true" />
                </NavLink>
              }
            </div>
          </header>

          <div className="header__toggler">
            {[{ short: 'en', full: t('header.en'), url: 'https://150years.frieslandcampina.com/en/' }, { short: 'nl', full: t('header.nl'), url: 'https://150jaar.frieslandcampina.com/nl/' }].filter(lang => lang.short != s0.Fc150YearsMainPage.lang).map(avLang => (
              <a className="header__language typo--4xs"
                onClick={(_) =>
                  window.dataLayer.push({
                    event: "event.fccorporate", category: "Language", action: avLang.full, label: window.location.pathname
                  })
                }
                href={avLang.url}>
                {avLang.short}
              </a>
            ))}

            <button className="menu-toggler" aria-expanded={props.menu == "open" ? true : false} aria-controls="a11y-menu" onClick={_ => setState(toggleHeader)}>
              <span className="sr-text">Open menu</span>
              <div className="menu-toggler__icon" aria-hidden="true">
                <span className="menu-toggler__line"></span>
                <span className="menu-toggler__line"></span>
                <span className="menu-toggler__line"></span>
                <span className="menu-toggler__line"></span>
              </div>
            </button>
          </div>

          <nav className="menu anim__wrap" aria-hidden={props.menu == "open" ? false : true}>
            <div className="menu__inner">
              <div className="menu__scroll">
                <MainNavItems
                  location="main"
                  hasActiveState={true}
                  s0={s0}
                />

                <ul className="languages typo--3xs">
                  {[{ short: 'en', full: t('header.en'), url: 'https://150years.frieslandcampina.com/en/' }, { short: 'nl', full: t('header.nl'), url: 'https://150jaar.frieslandcampina.com/nl/' }].filter(lang => lang.short != s0.Fc150YearsMainPage.lang).map(avLang => (
                    <li className="languages__item" key={`menu-lang-${avLang.short}`}>
                      <a className="languages__link"
                        onClick={(_) =>
                          window.dataLayer.push({
                            event: "event.fccorporate", category: "Language", action: avLang.full, label: window.location.pathname
                          })
                        }
                        href={avLang.url}>
                        {avLang.full}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="menu__waves anim__waves" aria-hidden="true">
              <Wave fill='rgb(255, 255, 255, .5)'
                paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                options={{
                  height: 60,
                  amplitude: 10,
                  speed: 0.1,
                  points: 8
                }}
                className="menu__wave anim__wave"
              />
              <Wave fill='rgb(255, 255, 255, .65)'
                paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                options={{
                  height: 60,
                  amplitude: 10,
                  speed: 0.1,
                  points: 5
                }}
                className="menu__wave anim__wave"
              />
            </div>
            <div className="menu__shape anim__shape" aria-hidden="true" />
          </nav>
        </>
      )
    }
  })
  